import gql from "graphql-tag";

export default gql`
  fragment LoginTokenFragment on LoginToken {
    token
    expiration
  }
`